var map = {
	"./administracion-de-empresas.jpg": 554,
	"./administracion-de-personal.jpg": 682,
	"./administracion-de-sistemas-de-mantenimiento.jpg": 656,
	"./administracion-tributaria.jpg": 997,
	"./banner.jpg": 658,
	"./higiene-y-seguridad-industrial.jpg": 38,
	"./informatica.jpg": 887,
	"./inscripcion.jpg": 937,
	"./iuta-barcelona.jpg": 575,
	"./iuta-plc.jpg": 959,
	"./iuta-puerto-la-cruz.jpg": 994,
	"./iuta-puerto-piritu.jpg": 815,
	"./logistica-industrial.jpg": 329,
	"./map.jpg": 332,
	"./nuevos.jpg": 652,
	"./tecnologia-de-gas.jpg": 71,
	"./tecnologia-instrumentista.jpg": 456,
	"./tecnologia-petrolera.jpg": 308,
	"./wall.jpg": 512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 259;